import { css } from 'styled-components'
import { he } from '../../locales/he'
import { fonts } from '../../styles/GlobalVariables'

export const adPlacementTextCss = css`
  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: '${he.ad}';
    font-family: ${fonts.default};
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.04em;
    text-align: center;
    color: #7b8588;
  }
`
export const AdPlacementCss = ({
  width,
  height,
  display = 'block',
}: {
  width: number
  height: number
  display?: 'flex' | 'block'
}) => css`
  display: ${display} !important;
  min-width: ${width}px;
  min-height: ${height}px !important;
  width: fit-content;
  position: relative;
  background-color: #f8f8f8;
  z-index: 1;
  max-width: 100%;
  ${adPlacementTextCss}
`
export default AdPlacementCss
